<template>
  <div v-if="data && data.Waves && data.KpiItem?.Questions && state">
    <b-button @click="toggle(undefined)" class="mb-2">
      <span v-if="state.some((x) => x.show === false)">Open all</span>
      <span v-else>Close all</span>
    </b-button>
    <div class="kq-container">
      <collapsible-panel v-for="(question, index) in data.KpiItem.Questions" :key="index"
        class="kq-item form-group" content-class=""
        v-model="state[index].show" :header="`${question.QuestionNumber} ${question.QuestionText}`">
          <div
            class="kq-table-row kq-table-head"
            :style="{ 'grid-template-columns': columnStyle }"
          >
            <div></div>
            <div v-for="(wave, j) in data.Waves" :key="j">
              {{ wave.SurveyWaveName }} <br />
              n:
              {{
                getWaveByName(question.Waves, wave.SurveyWaveName)
                  ?.QuestionSurveyInstanceCount
              }}
            </div>
          </div>

          <div
            class="kq-table-row kq-table-row-underline"
            v-for="(answer, j) in question.Answers ?? []"
            :key="j"
            :style="{ 'grid-template-columns': columnStyle }"
          >
            <div class="kq-table-item">{{ answer.AnswerText }}</div>
            <div class="kq-table-item" v-for="(wave, k) in data.Waves" :key="k">
              {{
                getWaveByName(answer.Waves, wave.SurveyWaveName)
                  ?.SurveyInstanceCount
              }}
            </div>
          </div>
      </collapsible-panel>
    </div>
  </div>
</template>

<script>
import CollapsiblePanel from '@/components/CollapsiblePanel';

export default {
  components: {
    CollapsiblePanel
  },

  props: {
    data: { type: Object, required: true },
  },

  data() {
    return {
      state: null,
    };
  },

  computed: {
    columnStyle() {
      return `3fr${" 1fr".repeat(this.data?.Waves?.length)}`;
    },
  },

  mounted() {
    this.state = Array.from(
      { length: this.data?.KpiItem?.Questions?.length },
      (x) => (x = { show: false })
    );
  },

  methods: {
    isItemVisible(index) {
      return this.state[index] && this.state[index].show;
    },

    toggle(index) {
      if (index === undefined) {
        let isClosed = this.state.some((x) => x.show === false);
        for (let i = 0; i < this.state.length; i++) {
          this.state[i].show = isClosed ? true : !this.state[i].show;
        }
      } else {
        this.state[index].show = !this.state[index].show;
      }
    },

    getWaveByName(waves, waveName) {
      return waves?.find((wave) => wave.SurveyWaveName == waveName);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/../scss/bmw/_variables.scss";

.coll-hidden {
  cursor: pointer;
  border-radius: 6px;
  outline: none;
}
.coll-visible:after,
.coll-hidden:after {
  float: right;
  margin-right: 1rem;
}
.coll-visible:after {
  content: "\02716"; // Unicode character for "plus" sign (+) */
}
.coll-hidden:after {
  content: "\0271A"; // Unicode character for "x" sign (x) */
}

.kq-table-row {
  display: grid;
  row-gap: 0.5rem;
}
.kq-table-row-underline {
  border-bottom: 1px solid $bmw-bg21;
}
.kq-table-row-underline:last-child {
  border-bottom: 0px;
}
.kq-table-item {
  display: flex;
  align-items: center;
  justify-content: center;
}
.kq-table-head {
  background: $bmw-2021-bg-light;
  color: $bmw-2021-fg;
  font-weight: 600;
}
.kq-header {
  color: $bmw-2021-fg;
  background: $bmw-bd21;
  font-weight: 900;
  padding: 1rem 0rem;
}
.kq-container {
  display: grid;
  grid-template-columns: 1fr;
}
.kq-item {
  text-align: center;
  border-radius: 8px;
  border: 2px solid $bmw-bg21;
}
</style>